// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ADda","top":"styles_top__3CgNQ","left":"styles_left__1rU99","description":"styles_description__2dlg_"};